import React, { useContext, useEffect, useState } from 'react';
import './authStyle.scss';
import ReactDOM from 'react-dom';
import { QRCodeSVG } from 'qrcode.react';
// import { SecondaryButton, TextBox } from '../FormInput';
import { CircularProgress, Grid, Hidden, Typography, Container, Tooltip, IconButton, Button } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CropSquareIcon from '@material-ui/icons/CropSquare';
import MenuIcon from '@material-ui/icons/Menu';
// import { getAuthenticatorCode, postAuthenticationCode, postAuthenticationValidateCode } from '';
// import AppContext from '../../App/AppContext';
// import { AppStorage } from '../Service/storage-service';
import CancelIcon from '@material-ui/icons/Cancel';
import { SecondaryButton, TextBox } from '../../../Core/Controls';
// import QrImage from './QrImage.png';
import { getAuthenticatorCode, postAuthenticationCode } from './../../../Core/Services/authenticator-service';
import { AppStorage } from '../../../Core/Basic/storage-service';
import { useToast } from '../../../Core/Hooks/useToast';
import { Alert } from '@material-ui/lab';
// import ContentCopyIcon from '@material-ui/icons/ContentCopy';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import OtpInput from '../../../Core/Controls/Otp_InputFields';

const AuthenticationScreen = (props) => {
    // const { portalSettings, showTopNavAndMenu, loggedIn, isTopNav, getUserPreference } = useContext(AppContext);

    const { showToastSuccess, showToastWarning, showToastError } = useToast();

    const [state, setState] = useState({
        codeUrl: '',
        securityKey: '',
        code: '',
        securityKeyARRAY: []
    });
    const [btnLoader, setBtnLoader] = useState(false);

    // const { hideModal, showToast, portalSettings } = useContext(AppContext);
    // const img = !!portalSettings.portalSettingMainLogo ? portalSettings.portalSettingMainLogo : `${process.env.PUBLIC_URL}/${portalSettings.portalSettingLogo}`;
    // const [isTwoFA, setIsTwoFA] = useState(AppStorage.getTwoFactorEnabled());
    useEffect(async () => {
        // if (props.temporaryToken) {
        let res = await getAuthenticatorCode(props.temporaryToken);
        if (res.success) {
            setState((st) => ({
                ...st,
                codeUrl: res.data.barcodeUri,
                securityKey: res.data.sharedKey
            }));
        }
        // }
    }, []);

    useEffect(() => {
        setState((st) => ({
            ...st,
            securityKeyARRAY: st.securityKey.split(' ')
        }));
    }, [state.securityKey]);

    const handleInput = (value) => {
        // const { value } = e.target;
        setState((st) => ({ ...st, code: value }));
    };

    const handleAuth = async () => {
        try {
            setBtnLoader(true);
            let res = await postAuthenticationCode(state.code, props.temporaryToken);
            if (res.success) {
                AppStorage.setTwoFlag(true);
                props.onClose(true);
                showToastSuccess(
                    'Your login has been successfully registered for two-factor authentication. You will need to enter the six digit number displayed in the authenticator app when asked to login into the system.'
                );
            } else {
                showToastError(res.message);
            }
        } catch (error) {
            showToastError(error?.message || 'Something went wrong');
        } finally {
            setBtnLoader(false);
        }
    };

    const CopySecurityCode = () => {
        navigator.clipboard.writeText(state.securityKey);
        showToastSuccess('Security Key copied to clipboard');
    };

    return (
        <div className="authVerificationCode">
            <Hidden only={['sm', 'lg', 'md', 'xs']}>
                <div className="authMain">
                    <div className="authModal">
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={6}>
                                <Grid Grid container justifyContent="center">
                                    <Grid item xs={12}>
                                        <div className="authDetails">
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Alert severity="error">Two-factor Authentication is off</Alert>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="h5"
                                                        style={{ textAlign: 'left', fontWeight: 600, color: '#1f3758', display: 'inline-block' }}
                                                    >
                                                        <span severity="success">Setup Authenticator</span>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <div className="stepText" style={{ textAlign: 'left' }}>
                                                        <div>
                                                            {' '}
                                                            <span>Step 1</span> Scan QR Code
                                                        </div>
                                                        <span> Complete authentication by scanning the QR code shown in an Authenticator App</span>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <div className="stepText" style={{ textAlign: 'left' }}>
                                                        <div>
                                                            {' '}
                                                            <span>Step 2</span> Install an Authenticator App
                                                        </div>
                                                        <span>
                                                            {' '}
                                                            You may use Microsoft/Google Authenticator (download from App/Play Store) or any other Authenticator
                                                            App of your choice
                                                        </span>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <div className="stepText" style={{ textAlign: 'left' }}>
                                                        <div>
                                                            {' '}
                                                            <span>Step 3</span> Enter Authentication Code
                                                        </div>
                                                        <span>
                                                            {' '}
                                                            Once you have downloaded the Authenticator app, you can scan the QR code to continue with the
                                                            enrollment, enter the authentication code displayed in the app and press the Submit button
                                                        </span>
                                                    </div>
                                                </Grid>

                                                <Grid item xs={12} className="sk-container">
                                                    <Typography variant="body2" className="sk-title">
                                                        Security Key
                                                    </Typography>

                                                    <div className="sk-box">{state.securityKey}</div>

                                                    <Button variant="outlined" startIcon={<FileCopyIcon />} className="sk-copy-btn" onClick={CopySecurityCode}>
                                                        Copy code
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid item xs={12} sm={12} md={5}>
                                <Grid Grid container justifyContent="center">
                                    <Grid item xs={5}>
                                        <div className="notch">-</div>
                                        <div className="MobileView">
                                            <div>
                                                <div className="qrScanner">
                                                    <Typography
                                                        variant="body1"
                                                        style={{ textAlign: 'center', fontSize: 15, fontWeight: 600, marginBottom: 10 }}
                                                    >
                                                        Scan the QR Code below
                                                    </Typography>{' '}
                                                    {/* <img src={img} /> */}
                                                    {state.codeUrl != '' ? (
                                                        <QRCodeSVG value={state.codeUrl} size={230} level="Q" fgColor="#1f3758" />
                                                    ) : (
                                                        <CircularProgress />
                                                    )}
                                                    <br />
                                                    <br />
                                                    {/* <TextBox placeholder="Authentication Code" className="Textbox" onChange={handleInput} value={state.code} /> */}
                                                    <span style={{ marginTop: 10 }}>
                                                        <OtpInput length={6} onChange={(code) => handleInput(code)} />
                                                    </span>
                                                    <SecondaryButton isBtnLoader={btnLoader} fullWidth onClick={handleAuth} style={{ marginTop: 20 }}>
                                                        Submit
                                                    </SecondaryButton>
                                                    <br />
                                                    {/* <Typography variant="caption" color="primary" style={{ textAlign: 'left' }}>
                                                go back
                                            </Typography> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </Hidden>
            <Hidden only={['xl']}>
                <Grid container spacing={0} alignContent="center">
                    <Grid item xs={12} sm={12} md={6}>
                        <Grid Grid container justifyContent="center">
                            <Grid item xs={12}>
                                <div className="authDetails">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Alert severity="error">Two-factor Authentication is off</Alert>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="h5" style={{ textAlign: 'left', fontWeight: 600, color: '#1f3758', display: 'inline-block' }}>
                                                <span severity="success">Setup Authenticator</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className="stepText" style={{ textAlign: 'left' }}>
                                                <div>
                                                    {' '}
                                                    <span>Step 1</span> Scan QR Code
                                                </div>
                                                <span> Complete authentication by scanning the QR code shown in an Authenticator App</span>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className="stepText" style={{ textAlign: 'left' }}>
                                                <div>
                                                    {' '}
                                                    <span>Step 2</span> Install an Authenticator App
                                                </div>
                                                <span>
                                                    {' '}
                                                    You may use Microsoft/Google Authenticator (download from App/Play Store) or any other Authenticator App of
                                                    your choice
                                                </span>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className="stepText" style={{ textAlign: 'left' }}>
                                                <div>
                                                    {' '}
                                                    <span>Step 3</span> Enter Authentication Code
                                                </div>
                                                <span>
                                                    {' '}
                                                    Once you have downloaded the Authenticator app, you can scan the QR code to continue with the enrollment,
                                                    enter the authentication code displayed in the app and press the Submit button
                                                </span>
                                            </div>
                                        </Grid>

                                        <Grid item xs={12} className="sk-container">
                                            <Typography variant="body2" className="sk-title">
                                                Security Key
                                            </Typography>

                                            <div className="sk-box">{state.securityKey}</div>

                                            <Button variant="outlined" startIcon={<FileCopyIcon />} className="sk-copy-btn" onClick={CopySecurityCode}>
                                                Copy code
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <hr />
                    <Grid item xs={12} sm={12} md={5}>
                        <Grid Grid container justifyContent="center">
                            <Grid item xs={12}>
                                <div className="MobileView">
                                    <div>
                                        <div className="qrScanner">
                                            <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 600, marginBottom: 10 }}>Scan the QR Code below</div>{' '}
                                            {state.codeUrl != '' ? (
                                                <QRCodeSVG
                                                    value={state.codeUrl}
                                                    size={180}
                                                    level="Q"
                                                    fgColor="#1f3758"
                                                    // imageSettings={{
                                                    //     src: { QrImage },
                                                    //     x: undefined,
                                                    //     y: undefined,
                                                    //     height: 24,
                                                    //     width: 24,
                                                    //     excavate: true
                                                    // }}
                                                />
                                            ) : (
                                                <CircularProgress />
                                            )}
                                            <br />
                                            <br />
                                            <span style={{ marginTop: 20 }}>
                                                <OtpInput length={6} onChange={(code) => handleInput(code)} />
                                            </span>
                                            <SecondaryButton isBtnLoader={btnLoader} fullWidth onClick={handleAuth} style={{ marginTop: 20 }}>
                                                Submit
                                            </SecondaryButton>
                                            <br />
                                            {/* <Typography variant="caption" color="primary" style={{ textAlign: 'left' }}>
                                                go back
                                            </Typography> */}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="buttons">
                                    <MenuIcon color="white" size="small" style={{ fontSize: 17 }} />
                                    &nbsp;&nbsp; &nbsp;&nbsp;
                                    <CropSquareIcon color="white" size="small" style={{ fontSize: 17 }} />
                                    &nbsp;&nbsp; &nbsp;&nbsp;
                                    <ArrowBackIosIcon color="white" size="small" style={{ fontSize: 17 }} />
                                </div> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Hidden>
        </div>
    );
};

export default AuthenticationScreen;
